// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main--wrapper--230mf","triangle":"main--triangle--3wmRF","expanded":"main--expanded--3Xtn3","content":"main--content--1TTdp"};